// // import { motion } from "framer-motion";
// // import { Swiper, SwiperSlide } from "swiper/react";
// // import { Autoplay, Pagination, EffectCreative } from "swiper/modules";
// // import "swiper/css";
// // import "swiper/css/pagination";
// // import "swiper/css/effect-creative";

// // const services = [
// //   {
// //     title: "B2B Database Construction",
// //     description:
// //       "Develop -verified company databases with owner/CXO contacts, size, revenue, and live market segments for India-focused sales.",
// //     icon: "🏢",
// //     features: [
// //       "Segment by vertical, region, and turnover",
// //       "Exclusive MSME & startup enrichments",
// //       "Real-time KYC & MCA record match",
// //       "CXO, founder, and purchase head discovery",
// //     ],
// //     color: "from-blue-600 to-blue-800",
// //   },
// //   {
// //     title: "Event Attendee Profiling",
// //     description:
// //       "Create rich, GDPR-compliant attendee lists for expos, trade fairs and webinars with pre- & post-engagement analytics.",
// //     icon: "🎪",
// //     features: [
// //       "Behavioral pattern scoring",
// //       // "Bulk WhatsApp and SMS reach options",
// //       "Personalized follow-ups",
// //       "ROI measurement framework",
// //     ],
// //     color: "from-purple-600 to-purple-800",
// //   },
// //   {
// //     title: "Market Intelligence",
// //     description:
// //       "Deliver market maps and competitor benchmarking for India’s top industries—from BFSI to SaaS to Education.",
// //     icon: "🔍",
// //     features: [
// //       "Competitor benchmarking reports",
// //       "TAM/SAM/SOM sizing",
// //       "Emerging trend detection",
// //       "SWOT with India-focused context",
// //     ],
// //     color: "from-green-600 to-green-800",
// //   },
// //   {
// //     title: "Customer Data Integration",
// //     description:
// //       "Unify and deduplicate customer data (incl. , PAN, mobile, email) from all sales/marketing touchpoints into a single, actionable record.",
// //     icon: "🔄",
// //     features: [
// //       "Multi-channel, CRM-first mapping",
// //       "Customer journey & engagement scoring",
// //       "Lifetime value (LTV) estimation",
// //       "Automated personalization triggers",
// //     ],
// //     color: "from-amber-600 to-amber-800",
// //   },
// //   {
// //     title: "Predictive Model Databases",
// //     description:
// //       "Organize datasets for AI/ML projects like churn prediction, upsell/cross-sell, credit risk, with Indian behaviors (RFM, UPI, etc).",
// //     icon: "🧠",
// //     features: [
// //       "Propensity & RFM segmentation",
// //       "B2B churn likelihood marks",
// //       "Next-best-action AIs",
// //       "Risk/fraud detection data",
// //     ],
// //     color: "from-red-600 to-red-800",
// //   },
// //   {
// //     title: "Compliance Databases",
// //     description:
// //       "Construct datasets fully compliant with India's DPDP, GDPR, and RBI guidelines—incl. traceable user consent and audit trails.",
// //     icon: "🛡️",
// //     features: [
// //       "Consent management workflows",
// //       "Audit trail logs & reports",
// //       "RBI, MCA, and DPDP overlays",
// //       "Industry/stakeholder specific",
// //     ],
// //     color: "from-indigo-600 to-indigo-800",
// //   },
// // ];

// // const successStories = [
// //   {
// //     metric: "40%",
// //     title: "Increase in Lead Quality",
// //     description:
// //       "For India’s fintech startup with automated firmographic enrichment &  data validation",
// //     logo: "📊",
// //   },
// //   {
// //     metric: "35%",
// //     title: "Boost in Event Engagement",
// //     description:
// //       "National edtech saw record turnout via pre-profiled attendee segments",
// //     logo: "🎯",
// //   },
// //   {
// //     metric: "3x",
// //     title: "Faster Data Processing",
// //     description:
// //       "AI-powered cleansing achieved in <24h for Noida-based SaaS client",
// //     logo: "⚡",
// //   },
// // ];

// // const fadeInUp = {
// //   hidden: { opacity: 0, y: 22 },
// //   visible: { opacity: 1, y: 0 },
// // };
// // const staggerContainer = { visible: { transition: { staggerChildren: 0.1 } } };

// // const DataBuildServices = () => (
// //   <div className="bg-gray-50">
// //     {/* Hero Section */}
// //     <section className="relative bg-gradient-to-r from-blue-800 to-blue-900 text-white py-28 px-4 sm:px-6 lg:px-8 overflow-hidden">
// //       <motion.div
// //         initial={{ opacity: 0 }}
// //         animate={{ opacity: 0.1 }}
// //         transition={{ duration: 1.2 }}
// //         className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=1200&q=80')] bg-cover bg-center"
// //       />
// //       <div className="relative max-w-7xl mx-auto">
// //         <motion.div
// //           initial="hidden"
// //           animate="visible"
// //           variants={staggerContainer}
// //           className="text-center"
// //         >
// //           <motion.h1
// //             variants={fadeInUp}
// //             className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 font-serif"
// //           >
// //             Data Build Services
// //           </motion.h1>
// //           <motion.p
// //             variants={fadeInUp}
// //             className="text-xl md:text-2xl max-w-3xl mx-auto"
// //           >
// //             From Raw Indian Data to Revenue-driving Intelligence
// //           </motion.p>
// //         </motion.div>
// //       </div>
// //     </section>

// //     {/* Expertise Intro */}
// //     <section className="py-20 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto">
// //       <motion.div
// //         initial="hidden"
// //         whileInView="visible"
// //         viewport={{ once: true }}
// //         variants={staggerContainer}
// //         className="grid md:grid-cols-2 gap-12 items-center"
// //       >
// //         <motion.div variants={fadeInUp}>
// //           <h2 className="text-3xl md:text-4xl font-bold text-blue-900 mb-6 font-serif">
// //             Why Indian Data Needs Local Experts
// //           </h2>
// //           <p className="text-lg text-gray-700 mb-6">
// //             At Augere Strategies , we blend deep Indian business databases,
// //             KYC standards, and real-time enrichment to give you a sales
// //             edge—whether you target unicorns or local SMEs.
// //           </p>
// //           <div className="space-y-4">
// //             {[
// //               "500M+ validated business contacts",
// //               "99% data accuracy— and PAN checked",
// //               "Real-time data refreshes with consent trail",
// //               // "Bharat-to-Metro: data for every Indian region",
// //             ].map((item, index) => (
// //               <motion.div
// //                 key={index}
// //                 variants={fadeInUp}
// //                 whileHover={{ x: 4 }}
// //                 className="flex items-start"
// //               >
// //                 <svg
// //                   className="h-6 w-6 text-blue-600 mr-3 mt-0.5"
// //                   fill="none"
// //                   viewBox="0 0 24 24"
// //                   stroke="currentColor"
// //                 >
// //                   <path
// //                     strokeLinecap="round"
// //                     strokeLinejoin="round"
// //                     strokeWidth={2}
// //                     d="M5 13l4 4L19 7"
// //                   />
// //                 </svg>
// //                 <span className="text-gray-800 font-medium">{item}</span>
// //               </motion.div>
// //             ))}
// //           </div>
// //         </motion.div>
// //         <motion.div
// //           variants={fadeInUp}
// //           whileHover={{ scale: 1.03 }}
// //           transition={{ duration: 0.3 }}
// //           className="relative"
// //         >
// //           <div className="absolute -inset-4 bg-gradient-to-r from-blue-600 to-yellow-400 rounded-2xl opacity-15 blur-lg" />
// //           <div className="relative bg-white p-1 rounded-xl shadow-xl overflow-hidden">
// //             <img
// //               src="https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-4.0.3&auto=format&fit=crop&w=900&q=80"
// //               alt="Data analytics team"
// //               className="w-full h-auto rounded-lg"
// //             />
// //           </div>
// //         </motion.div>
// //       </motion.div>
// //     </section>

// //     {/* Our Approach */}
// //     <section className="py-20 bg-white">
// //       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
// //         <motion.div
// //           initial="hidden"
// //           whileInView="visible"
// //           viewport={{ once: true }}
// //           variants={staggerContainer}
// //           className="text-center mb-16"
// //         >
// //           <motion.h2
// //             variants={fadeInUp}
// //             className="text-3xl md:text-4xl font-bold text-blue-900 mb-4 font-serif"
// //           >
// //             Our Approach
// //           </motion.h2>
// //           <motion.p
// //             variants={fadeInUp}
// //             className="text-xl text-gray-700 max-w-3xl mx-auto"
// //           >
// //             From data discovery to enrichment and compliance: A stepwise,
// //             audit-friendly process
// //           </motion.p>
// //         </motion.div>
// //         <motion.div
// //           initial="hidden"
// //           whileInView="visible"
// //           viewport={{ once: true }}
// //           variants={staggerContainer}
// //           className="grid md:grid-cols-2 lg:grid-cols-3 gap-8"
// //         >
// //           {[
// //             {
// //               title: "Data Discovery",
// //               icon: "🔎",
// //               desc: "Thorough audit & mapping of all Indian business data sources (, MCA, CRM, WhatsApp, etc.).",
// //               color: "bg-blue-100 text-blue-700",
// //             },
// //             {
// //               title: "Custom Schema",
// //               icon: "🏗️",
// //               desc: "Build taxonomies for every industry, geography, company type, including local MSMEs.",
// //               color: "bg-orange-100 text-orange-700",
// //             },
// //             {
// //               title: "Integration",
// //               icon: "🔄",
// //               desc: "Merge data from all touchpoints, deduplicate, segment and link across your sales stack.",
// //               color: "bg-green-100 text-green-700",
// //             },
// //             {
// //               title: "Cleansing",
// //               icon: "✨",
// //               desc: "Automated removal of outdated, duplicate or error-prone records using AI and manual QA.",
// //               color: "bg-amber-100 text-amber-700",
// //             },
// //             {
// //               title: "Analytics",
// //               icon: "📊",
// //               desc: "Add leads scoring, trend detection and opportunity highlights aligned to India’s business cycles.",
// //               color: "bg-red-100 text-red-700",
// //             },
// //             {
// //               title: "Visualization",
// //               icon: "📈",
// //               desc: "Actionable dashboards and power BI for easy reporting and strategy.",
// //               color: "bg-indigo-100 text-indigo-700",
// //             },
// //           ].map((step, i) => (
// //             <motion.div
// //               key={step.title}
// //               variants={fadeInUp}
// //               whileHover={{
// //                 y: -8,
// //                 boxShadow: "0 12px 24px 0 rgba(37, 99, 235, 0.12)",
// //               }}
// //               className={`bg-gray-50 p-8 rounded-xl border border-gray-200 flex flex-col items-center ${step.color}`}
// //             >
// //               <div className="text-4xl mb-3">{step.icon}</div>
// //               <h3 className="text-xl font-bold text-blue-900 mb-2">
// //                 {step.title}
// //               </h3>
// //               <p className="text-gray-700 text-center">{step.desc}</p>
// //             </motion.div>
// //           ))}
// //         </motion.div>
// //       </div>
// //     </section>

// //     {/* Our Data Build Services */}
// //     <section className="py-20 bg-gradient-to-br from-gray-100 to-blue-50">
// //       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
// //         <motion.div
// //           initial="hidden"
// //           whileInView="visible"
// //           viewport={{ once: true }}
// //           variants={staggerContainer}
// //           className="text-center mb-14"
// //         >
// //           <motion.h2
// //             variants={fadeInUp}
// //             className="text-3xl md:text-4xl font-bold text-blue-900 mb-4 font-serif"
// //           >
// //             Our Data Build Solutions
// //           </motion.h2>
// //           <motion.p
// //             variants={fadeInUp}
// //             className="text-xl text-gray-700 max-w-3xl mx-auto"
// //           >
// //             Choose a solution below for details on how we empower every business
// //             with actionable data
// //           </motion.p>
// //         </motion.div>
// //         <motion.div
// //           initial="hidden"
// //           whileInView="visible"
// //           viewport={{ once: true }}
// //           variants={staggerContainer}
// //           className="grid md:grid-cols-2 lg:grid-cols-3 gap-8"
// //         >
// //           {services.map((service, index) => (
// //             <motion.div
// //               key={service.title}
// //               variants={fadeInUp}
// //               whileHover={{
// //                 y: -12,
// //                 boxShadow: "0 14px 26px 0 rgba(59, 130, 246, 0.17)",
// //               }}
// //               className="bg-white rounded-xl shadow px-0 pb-0 overflow-hidden transition-all duration-300 group"
// //             >
// //               <div
// //                 className={`h-44 bg-gradient-to-r ${service.color} flex items-center relative`}
// //               >
// //                 <div className="absolute left-5 top-7 text-5xl text-white">
// //                   {service.icon}
// //                 </div>
// //                 <h3 className="absolute left-5 bottom-4 text-xl font-bold text-white drop-shadow">
// //                   {service.title}
// //                 </h3>
// //                 <div className="absolute right-0 bottom-0 w-44 h-36 bg-white/10 blur-2xl rounded-full"></div>
// //               </div>
// //               <div className="p-6">
// //                 <p className="text-gray-700 mb-3">{service.description}</p>
// //                 <ul className="space-y-2 mb-4">
// //                   {service.features.map((feature, i) => (
// //                     <li key={i} className="flex items-start">
// //                       <svg
// //                         className="h-5 w-5 text-blue-600 mr-2 mt-0.5"
// //                         fill="none"
// //                         viewBox="0 0 24 24"
// //                         stroke="currentColor"
// //                       >
// //                         <path
// //                           strokeLinecap="round"
// //                           strokeLinejoin="round"
// //                           strokeWidth={2}
// //                           d="M5 13l4 4L19 7"
// //                         />
// //                       </svg>
// //                       <span className="text-gray-800">{feature}</span>
// //                     </li>
// //                   ))}
// //                 </ul>
// //                 <motion.button
// //                   whileHover={{
// //                     scale: 1.04,
// //                     backgroundColor: "#1e40af",
// //                     color: "#fff",
// //                   }}
// //                   whileTap={{ scale: 0.96 }}
// //                   className="w-full py-2 px-4 border border-blue-700 text-blue-700 font-semibold rounded-lg hover:bg-blue-700 hover:text-white transition-all"
// //                 >
// //                   Learn More
// //                 </motion.button>
// //               </div>
// //             </motion.div>
// //           ))}
// //         </motion.div>
// //       </div>
// //     </section>

// //     {/* Success Stories Carousel */}
// //     <section className="py-20 bg-gradient-to-br from-gray-900 via-blue-950 to-blue-900 text-white relative overflow-hidden">
// //       <motion.div
// //         initial={{ opacity: 0 }}
// //         whileInView={{ opacity: 0.13 }}
// //         transition={{ duration: 1 }}
// //         className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1517984920795-ee602e6da9a7?auto=format&fit=crop&w=1200&q=80')] bg-cover bg-center"
// //       />
// //       <div className="absolute inset-0 bg-gradient-to-b from-transparent to-black/70"></div>
// //       <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
// //         <motion.div
// //           initial="hidden"
// //           whileInView="visible"
// //           viewport={{ once: true }}
// //           variants={staggerContainer}
// //           className="text-center mb-14"
// //         >
// //           <motion.h2
// //             variants={fadeInUp}
// //             className="text-3xl md:text-4xl font-bold mb-4 font-serif"
// //           >
// //             Indian Success Stories
// //           </motion.h2>
// //           <motion.p
// //             variants={fadeInUp}
// //             className="text-xl max-w-3xl mx-auto opacity-90"
// //           >
// //             Real results for real Indian enterprises, from unicorns to MSMEs.
// //           </motion.p>
// //         </motion.div>
// //         <Swiper
// //           slidesPerView={1}
// //           spaceBetween={30}
// //           loop={true}
// //           autoplay={{ delay: 4500, disableOnInteraction: false }}
// //           pagination={{ clickable: true, dynamicBullets: true }}
// //           effect={"creative"}
// //           creativeEffect={{
// //             prev: {
// //               shadow: true,
// //               translate: [0, 0, -400],
// //             },
// //             next: {
// //               translate: ["100%", 0, 0],
// //             },
// //           }}
// //           breakpoints={{
// //             640: { slidesPerView: 2, spaceBetween: 20 },
// //             1024: { slidesPerView: 3, spaceBetween: 30 },
// //           }}
// //           modules={[Autoplay, Pagination, EffectCreative]}
// //           className="pb-12"
// //         >
// //           {successStories.map((story, index) => (
// //             <SwiperSlide key={index}>
// //               <motion.div
// //                 whileHover={{
// //                   y: -12,
// //                   boxShadow: "0 14px 28px 0 rgba(255, 255, 255, 0.18)",
// //                 }}
// //                 className="bg-white/10 backdrop-blur p-8 rounded-xl h-full border border-white/20 relative group"
// //               >
// //                 <div className="absolute inset-0 bg-gradient-to-br from-blue-600/20 to-purple-600/15 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
// //                 <div className="relative z-10">
// //                   <div className="text-6xl font-bold mb-4 text-white">
// //                     {story.metric}
// //                   </div>
// //                   <div className="text-4xl mb-4 opacity-80">{story.logo}</div>
// //                   <h3 className="text-xl font-bold mb-3">{story.title}</h3>
// //                   <p className="opacity-85">{story.description}</p>
// //                 </div>
// //               </motion.div>
// //             </SwiperSlide>
// //           ))}
// //         </Swiper>
// //       </div>
// //     </section>

// //     {/* Final CTA */}
// //     <section className="py-20 bg-gradient-to-r from-blue-700 to-blue-900 text-white">
// //       <div className="max-w-4xl mx-auto px-4 text-center">
// //         <motion.h2 className="text-3xl md:text-4xl font-bold mb-6">
// //           Ready to unlock your next growth wave with Indian business data?
// //         </motion.h2>
// //         <motion.p className="text-xl mb-8 max-w-3xl mx-auto opacity-90">
// //           Connect with our experts today for a free sample dataset or a custom
// //           quote.
// //         </motion.p>
// //         <div className="flex flex-col sm:flex-row justify-center gap-4">
// //           <motion.a
// //             whileHover={{
// //               scale: 1.05,
// //               backgroundColor: "#fff",
// //               color: "#1d4ed8",
// //             }}
// //             whileTap={{ scale: 0.95 }}
// //             href="tel:+919834567890"
// //             className="px-8 py-4 bg-white text-blue-700 font-semibold rounded-lg transition-all text-lg"
// //           >
// //             +91 7021216035/8828357920
// //           </motion.a>
// //           <motion.a
// //             whileHover={{
// //               scale: 1.05,
// //               backgroundColor: "#fff",
// //               color: "#1d4ed8",
// //             }}
// //             whileTap={{ scale: 0.95 }}
// //             href="/get-quote"
// //             className="px-8 py-4 border-2 border-white text-white font-semibold rounded-lg hover:bg-white hover:text-blue-700 transition-all text-lg"
// //           >
// //             Get a Quote
// //           </motion.a>
// //           <motion.a
// //             whileHover={{
// //               scale: 1.05,
// //               backgroundColor: "#f97316",
// //               boxShadow: "0 10px 15px -3px rgba(249, 115, 22, 0.26)",
// //             }}
// //             whileTap={{ scale: 0.95 }}
// //             href="/free-sample"
// //             className="px-8 py-4 bg-orange-500 hover:bg-orange-600 text-white font-semibold rounded-lg transition-all text-lg"
// //           >
// //             Get Free Sample
// //           </motion.a>
// //         </div>
// //       </div>
// //     </section>
// //   </div>
// // );

// // export default DataBuildServices;

// import { motion } from "framer-motion";
// import { Swiper, SwiperSlide } from "swiper/react";
// import { Autoplay, Pagination, EffectCreative } from "swiper/modules";
// import "swiper/css";
// import "swiper/css/pagination";
// import "swiper/css/effect-creative";

// const services = [
//   {
//     title: "B2B Database Construction",
//     description:
//       "Target with precision. We build industry-specific databases with deep, -verified company profiles and CXO contacts to supercharge your sales and marketing efforts.",
//     icon: "🏢",
//     features: [
//       "Segment by vertical, region, and turnover",
//       "Exclusive MSME & startup enrichments",
//       "Real-time KYC & MCA record match",
//       "CXO, founder, and purchase head discovery",
//     ],
//     color: "from-blue-600 to-blue-800",
//   },
//   {
//     title: "Event Attendee Profiling",
//     description:
//       "Maximize event ROI. We create detailed, GDPR-compliant attendee profiles and analyze behavior to enhance engagement and tailor future marketing.",
//     icon: "🎪",
//     features: [
//       "Behavioral pattern scoring",
//       "Personalized follow-ups",
//       "ROI measurement framework",
//     ],
//     color: "from-purple-600 to-purple-800",
//   },
//   {
//     title: "Market Intelligence Databases",
//     description:
//       "Stay ahead of the curve. We compile trends, competitive insights, and market movements into actionable, sector-specific intelligence reports for India's top industries.",
//     icon: "🔍",
//     features: [
//       "Competitor benchmarking reports",
//       "TAM/SAM/SOM sizing",
//       "Emerging trend detection",
//       "SWOT with India-focused context",
//     ],
//     color: "from-green-600 to-green-800",
//   },
//   {
//     title: "360-Degree Customer View",
//     description:
//       "Deepen customer relationships. We integrate and deduplicate customer data from all touchpoints to enable hyper-personalized marketing and service strategies.",
//     icon: "🔄",
//     features: [
//       "Multi-channel, CRM-first mapping",
//       "Customer journey & engagement scoring",
//       "Lifetime value (LTV) estimation",
//       "Automated personalization triggers",
//     ],
//     color: "from-amber-600 to-amber-800",
//   },
//   {
//     title: "Predictive Model Databases",
//     description:
//       "Anticipate what's next. We build the foundational datasets for AI/ML models, enabling churn prediction, propensity modeling, and future-ready planning based on Indian market behaviors.",
//     icon: "🧠",
//     features: [
//       "Propensity & RFM segmentation",
//       "B2B churn likelihood marks",
//       "Next-best-action AIs",
//       "Risk/fraud detection data",
//     ],
//     color: "from-red-600 to-red-800",
//   },
//   {
//     title: "Compliance & Regulatory Databases",
//     description:
//       "Operate with confidence. We construct datasets designed for India's DPDP, GDPR, and RBI guidelines, ensuring robust governance and simplified audits.",
//     icon: "🛡️",
//     features: [
//       "Consent management workflows",
//       "Audit trail logs & reports",
//       "RBI, MCA, and DPDP overlays",
//       "Industry/stakeholder specific",
//     ],
//     color: "from-indigo-600 to-indigo-800",
//   },
// ];

// const successStories = [
//   {
//     metric: "40%",
//     title: "Increase in Lead Quality",
//     description:
//       "For a fintech startup with automated firmographic enrichment &  validation.",
//     logo: "📊",
//   },
//   {
//     metric: "35%",
//     title: "Boost in Event Engagement",
//     description:
//       "An edtech client saw record turnout via pre-profiled attendee segments.",
//     logo: "🎯",
//   },
//   {
//     metric: "3x",
//     title: "Faster Data Processing",
//     description:
//       "AI-powered cleansing achieved in <24h for a Noida-based SaaS client.",
//     logo: "⚡",
//   },
// ];

// const fadeInUp = {
//   hidden: { opacity: 0, y: 22 },
//   visible: { opacity: 1, y: 0 },
// };
// const staggerContainer = { visible: { transition: { staggerChildren: 0.1 } } };

// const DataBuildServices = () => (
//   <div className="bg-gray-50">
//     {/* Hero Section */}
//     <section className="relative bg-gradient-to-r from-blue-800 to-blue-900 text-white py-28 px-4 sm:px-6 lg:px-8 overflow-hidden">
//       <motion.div
//         initial={{ opacity: 0 }}
//         animate={{ opacity: 0.1 }}
//         transition={{ duration: 1.2 }}
//         className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=1200&q=80')] bg-cover bg-center"
//       />
//       <div className="relative max-w-7xl mx-auto">
//         <motion.div
//           initial="hidden"
//           animate="visible"
//           variants={staggerContainer}
//           className="text-center"
//         >
//           <motion.h1
//             variants={fadeInUp}
//             className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 font-serif"
//           >
//             Data Build Services
//           </motion.h1>
//           <motion.p
//             variants={fadeInUp}
//             className="text-xl md:text-2xl max-w-3xl mx-auto"
//           >
//             From Raw Data to Strategic Advantage
//           </motion.p>
//         </motion.div>
//       </div>
//     </section>

//     {/* Expertise Intro */}
//     <section className="py-20 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto">
//       <motion.div
//         initial="hidden"
//         whileInView="visible"
//         viewport={{ once: true }}
//         variants={staggerContainer}
//         className="grid md:grid-cols-2 gap-12 items-center"
//       >
//         <motion.div variants={fadeInUp}>
//           <h2 className="text-3xl md:text-4xl font-bold text-blue-900 mb-6 font-serif">
//             Transforming Data into Actionable Intelligence
//           </h2>
//           <p className="text-lg text-gray-700 mb-6">
//             At Augere Strategies , we specialize in crafting bespoke data
//             solutions that empower businesses to make informed decisions and
//             drive growth. We blend deep local expertise with robust processes to
//             turn complex, unstructured data into your most valuable strategic
//             asset.
//           </p>
//           <div className="space-y-4">
//             {[
//               "500M+ validated business contacts",
//               "99% data accuracy",
//               "Real-time data refreshes with consent trail",
//             ].map((item, index) => (
//               <motion.div
//                 key={index}
//                 variants={fadeInUp}
//                 whileHover={{ x: 4 }}
//                 className="flex items-start"
//               >
//                 <svg
//                   className="h-6 w-6 text-blue-600 mr-3 mt-0.5"
//                   fill="none"
//                   viewBox="0 0 24 24"
//                   stroke="currentColor"
//                 >
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth={2}
//                     d="M5 13l4 4L19 7"
//                   />
//                 </svg>
//                 <span className="text-gray-800 font-medium">{item}</span>
//               </motion.div>
//             ))}
//           </div>
//         </motion.div>
//         <motion.div
//           variants={fadeInUp}
//           whileHover={{ scale: 1.03 }}
//           transition={{ duration: 0.3 }}
//           className="relative"
//         >
//           <div className="absolute -inset-4 bg-gradient-to-r from-blue-600 to-yellow-400 rounded-2xl opacity-15 blur-lg" />
//           <div className="relative bg-white p-1 rounded-xl shadow-xl overflow-hidden">
//             <img
//               src="https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-4.0.3&auto=format&fit=crop&w=900&q=80"
//               alt="Data analytics team"
//               className="w-full h-auto rounded-lg"
//             />
//           </div>
//         </motion.div>
//       </motion.div>
//     </section>

//     {/* Our Approach */}
//     <section className="py-20 bg-white">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//         <motion.div
//           initial="hidden"
//           whileInView="visible"
//           viewport={{ once: true }}
//           variants={staggerContainer}
//           className="text-center mb-16"
//         >
//           <motion.h2
//             variants={fadeInUp}
//             className="text-3xl md:text-4xl font-bold text-blue-900 mb-4 font-serif"
//           >
//             Our Process for Building Intelligence
//           </motion.h2>
//           <motion.p
//             variants={fadeInUp}
//             className="text-xl text-gray-700 max-w-3xl mx-auto"
//           >
//             A stepwise, audit-friendly process from discovery to enrichment and
//             compliance.
//           </motion.p>
//         </motion.div>
//         <motion.div
//           initial="hidden"
//           whileInView="visible"
//           viewport={{ once: true }}
//           variants={staggerContainer}
//           className="grid md:grid-cols-2 lg:grid-cols-3 gap-8"
//         >
//           {[
//             {
//               title: "Discover & Assess",
//               icon: "🔎",
//               desc: "We analyze your existing data landscape to identify key information and potential gaps.",
//               color: "bg-blue-100 text-blue-700",
//             },
//             {
//               title: "Architect & Design",
//               icon: "🧩",
//               desc: "Our experts design tailored data structures that align with your specific business goals.",
//               color: "bg-orange-100 text-orange-700",
//             },
//             {
//               title: "Integrate & Unify",
//               icon: "🔄",
//               desc: "We seamlessly combine data from multiple sources, creating a unified and comprehensive dataset.",
//               color: "bg-green-100 text-green-700",
//             },
//             {
//               title: "Cleanse & Enrich",
//               icon: "✨",
//               desc: "Our robust processes ensure your data is accurate, up-to-date, and enriched with valuable attributes.",
//               color: "bg-amber-100 text-amber-700",
//             },
//             {
//               title: "Analyze & Predict",
//               icon: "📊",
//               desc: "We apply cutting-edge analytical techniques to uncover hidden patterns and generate predictive insights.",
//               color: "bg-red-100 text-red-700",
//             },
//             {
//               title: "Visualize & Report",
//               icon: "📈",
//               desc: "We transform complex data into clear, intuitive visualizations and reports for easy interpretation and strategy.",
//               color: "bg-indigo-100 text-indigo-700",
//             },
//           ].map((step, i) => (
//             <motion.div
//               key={step.title}
//               variants={fadeInUp}
//               whileHover={{
//                 y: -8,
//                 boxShadow: "0 12px 24px 0 rgba(37, 99, 235, 0.12)",
//               }}
//               className={`bg-gray-50 p-8 rounded-xl border border-gray-200 flex flex-col items-center ${step.color}`}
//             >
//               <div className="text-4xl mb-3">{step.icon}</div>
//               <h3 className="text-xl font-bold text-blue-900 mb-2">
//                 {step.title}
//               </h3>
//               <p className="text-gray-700 text-center">{step.desc}</p>
//             </motion.div>
//           ))}
//         </motion.div>
//       </div>
//     </section>

//     {/* Our Data Build Services */}
//     <section className="py-20 bg-gradient-to-br from-gray-100 to-blue-50">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//         <motion.div
//           initial="hidden"
//           whileInView="visible"
//           viewport={{ once: true }}
//           variants={staggerContainer}
//           className="text-center mb-14"
//         >
//           <motion.h2
//             variants={fadeInUp}
//             className="text-3xl md:text-4xl font-bold text-blue-900 mb-4 font-serif"
//           >
//             Our Data Build Solutions
//           </motion.h2>
//           <motion.p
//             variants={fadeInUp}
//             className="text-xl text-gray-700 max-w-3xl mx-auto"
//           >
//             Engineered for Results: Choose a solution to see how we empower your
//             business with actionable data.
//           </motion.p>
//         </motion.div>
//         <motion.div
//           initial="hidden"
//           whileInView="visible"
//           viewport={{ once: true }}
//           variants={staggerContainer}
//           className="grid md:grid-cols-2 lg:grid-cols-3 gap-8"
//         >
//           {services.map((service, index) => (
//             <motion.div
//               key={service.title}
//               variants={fadeInUp}
//               whileHover={{
//                 y: -12,
//                 boxShadow: "0 14px 26px 0 rgba(59, 130, 246, 0.17)",
//               }}
//               className="bg-white rounded-xl shadow px-0 pb-0 overflow-hidden transition-all duration-300 group"
//             >
//               <div
//                 className={`h-44 bg-gradient-to-r ${service.color} flex items-center relative`}
//               >
//                 <div className="absolute left-5 top-7 text-5xl text-white">
//                   {service.icon}
//                 </div>
//                 <h3 className="absolute left-5 bottom-4 text-xl font-bold text-white drop-shadow">
//                   {service.title}
//                 </h3>
//                 <div className="absolute right-0 bottom-0 w-44 h-36 bg-white/10 blur-2xl rounded-full"></div>
//               </div>
//               <div className="p-6">
//                 <p className="text-gray-700 mb-3">{service.description}</p>
//                 <ul className="space-y-2 mb-4">
//                   {service.features.map((feature, i) => (
//                     <li key={i} className="flex items-start">
//                       <svg
//                         className="h-5 w-5 text-blue-600 mr-2 mt-0.5"
//                         fill="none"
//                         viewBox="0 0 24 24"
//                         stroke="currentColor"
//                       >
//                         <path
//                           strokeLinecap="round"
//                           strokeLinejoin="round"
//                           strokeWidth={2}
//                           d="M5 13l4 4L19 7"
//                         />
//                       </svg>
//                       <span className="text-gray-800">{feature}</span>
//                     </li>
//                   ))}
//                 </ul>
//                 <motion.button
//                   whileHover={{
//                     scale: 1.04,
//                     backgroundColor: "#1e40af",
//                     color: "#fff",
//                   }}
//                   whileTap={{ scale: 0.96 }}
//                   className="w-full py-2 px-4 border border-blue-700 text-blue-700 font-semibold rounded-lg hover:bg-blue-700 hover:text-white transition-all"
//                 >
//                   Learn More
//                 </motion.button>
//               </div>
//             </motion.div>
//           ))}
//         </motion.div>
//       </div>
//     </section>

//     {/* Success Stories Carousel - Remains unchanged as it uses metrics */}
//     {/* <section className="py-20 bg-gradient-to-br from-gray-900 via-blue-950 to-blue-900 text-white relative overflow-hidden">
//       <motion.div
//         initial={{ opacity: 0 }}
//         whileInView={{ opacity: 0.13 }}
//         transition={{ duration: 1 }}
//         className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1517984920795-ee602e6da9a7?auto=format&fit=crop&w=1200&q=80')] bg-cover bg-center"
//       />
//       <div className="absolute inset-0 bg-gradient-to-b from-transparent to-black/70"></div>
//       <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//         <motion.div
//           initial="hidden"
//           whileInView="visible"
//           viewport={{ once: true }}
//           variants={staggerContainer}
//           className="text-center mb-14"
//         >
//           <motion.h2
//             variants={fadeInUp}
//             className="text-3xl md:text-4xl font-bold mb-4 font-serif"
//           >
//             Proven Impact
//           </motion.h2>
//           <motion.p
//             variants={fadeInUp}
//             className="text-xl max-w-3xl mx-auto opacity-90"
//           >
//             Real results for enterprises, from unicorns to MSMEs.
//           </motion.p>
//         </motion.div>
//         <Swiper
//           slidesPerView={1}
//           spaceBetween={30}
//           loop={true}
//           autoplay={{ delay: 4500, disableOnInteraction: false }}
//           pagination={{ clickable: true, dynamicBullets: true }}
//           effect={"creative"}
//           creativeEffect={{
//             prev: {
//               shadow: true,
//               translate: [0, 0, -400],
//             },
//             next: {
//               translate: ["100%", 0, 0],
//             },
//           }}
//           breakpoints={{
//             640: { slidesPerView: 2, spaceBetween: 20 },
//             1024: { slidesPerView: 3, spaceBetween: 30 },
//           }}
//           modules={[Autoplay, Pagination, EffectCreative]}
//           className="pb-12"
//         >
//           {successStories.map((story, index) => (
//             <SwiperSlide key={index}>
//               <motion.div
//                 whileHover={{
//                   y: -12,
//                   boxShadow: "0 14px 28px 0 rgba(255, 255, 255, 0.18)",
//                 }}
//                 className="bg-white/10 backdrop-blur p-8 rounded-xl h-full border border-white/20 relative group"
//               >
//                 <div className="absolute inset-0 bg-gradient-to-br from-blue-600/20 to-purple-600/15 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
//                 <div className="relative z-10">
//                   <div className="text-6xl font-bold mb-4 text-white">
//                     {story.metric}
//                   </div>
//                   <div className="text-4xl mb-4 opacity-80">{story.logo}</div>
//                   <h3 className="text-xl font-bold mb-3">{story.title}</h3>
//                   <p className="opacity-85">{story.description}</p>
//                 </div>
//               </motion.div>
//             </SwiperSlide>
//           ))}
//         </Swiper>
//       </div>
//     </section> */}

//     <section
//       style={{
//         maxWidth: "1000px",
//         margin: "2rem auto",
//         padding: "2.5rem",
//         background: "linear-gradient(135deg, #1e40af 0%, #3730a3 100%)",
//         color: "white",
//         borderRadius: "16px",
//         boxShadow: "0 10px 30px rgba(0, 0, 0, 0.15)",
//       }}
//     >
//       {/* Header */}
//       <div style={{ textAlign: "center", marginBottom: "2.5rem" }}>
//         <div
//           style={{
//             display: "inline-block",
//             background: "rgba(255, 255, 255, 0.15)",
//             padding: "0.5rem 1rem",
//             borderRadius: "20px",
//             fontSize: "0.85rem",
//             fontWeight: 500,
//             marginBottom: "1rem",
//           }}
//         >
//           SUCCESS METRICS
//         </div>
//         <h2
//           style={{
//             fontSize: "2rem",
//             fontWeight: 700,
//             marginBottom: "0.75rem",
//             color: "white",
//           }}
//         >
//           Proven Impact
//         </h2>
//         <p
//           style={{
//             fontSize: "1.1rem",
//             opacity: 0.9,
//             maxWidth: "500px",
//             margin: "0 auto",
//           }}
//         >
//           Real results for enterprises, from unicorns to MSMEs.
//         </p>
//       </div>

//       {/* Stats Cards */}
//       <div
//         style={{
//           display: "grid",
//           gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
//           gap: "1.25rem",
//         }}
//       >
//         {/* Card 1 */}
//         <div
//           style={{
//             background: "rgba(255, 255, 255, 0.1)",
//             borderRadius: "12px",
//             padding: "1.5rem",
//             textAlign: "center",
//           }}
//         >
//           <div
//             style={{
//               fontSize: "2.5rem",
//               fontWeight: 700,
//               color: "#93c5fd",
//               marginBottom: "0.5rem",
//             }}
//           >
//             40%
//           </div>
//           <h3
//             style={{
//               fontSize: "1.25rem",
//               fontWeight: 600,
//               marginBottom: "0.75rem",
//             }}
//           >
//             Increase in Lead Quality
//           </h3>
//           <p
//             style={{
//               opacity: 0.85,
//               fontSize: "0.95rem",
//               marginBottom: "1.25rem",
//             }}
//           >
//             For India's fintech startup with automated enrichment
//           </p>
//           <button
//             style={{
//               background: "rgba(255, 255, 255, 0.2)",
//               border: "none",
//               color: "white",
//               padding: "0.6rem 1.25rem",
//               borderRadius: "8px",
//               fontWeight: 500,
//               cursor: "pointer",
//             }}
//           >
//             Read Case Study
//           </button>
//         </div>

//         {/* Card 2 */}
//         <div
//           style={{
//             background: "rgba(255, 255, 255, 0.1)",
//             borderRadius: "12px",
//             padding: "1.5rem",
//             textAlign: "center",
//           }}
//         >
//           <div
//             style={{
//               fontSize: "2.5rem",
//               fontWeight: 700,
//               color: "#93c5fd",
//               marginBottom: "0.5rem",
//             }}
//           >
//             35%
//           </div>
//           <h3
//             style={{
//               fontSize: "1.25rem",
//               fontWeight: 600,
//               marginBottom: "0.75rem",
//             }}
//           >
//             Boost in Event Engagement
//           </h3>
//           <p
//             style={{
//               opacity: 0.85,
//               fontSize: "0.95rem",
//               marginBottom: "1.25rem",
//             }}
//           >
//             National edtech saw record turnout via pre-profiled segments
//           </p>
//           <button
//             style={{
//               background: "rgba(255, 255, 255, 0.2)",
//               border: "none",
//               color: "white",
//               padding: "0.6rem 1.25rem",
//               borderRadius: "8px",
//               fontWeight: 500,
//               cursor: "pointer",
//             }}
//           >
//             Read Case Study
//           </button>
//         </div>

//         {/* Card 3 */}
//         <div
//           style={{
//             background: "rgba(255, 255, 255, 0.1)",
//             borderRadius: "12px",
//             padding: "1.5rem",
//             textAlign: "center",
//           }}
//         >
//           <div
//             style={{
//               fontSize: "2.5rem",
//               fontWeight: 700,
//               color: "#93c5fd",
//               marginBottom: "0.5rem",
//             }}
//           >
//             3x
//           </div>
//           <h3
//             style={{
//               fontSize: "1.25rem",
//               fontWeight: 600,
//               marginBottom: "0.75rem",
//             }}
//           >
//             Faster Data Processing
//           </h3>
//           <p
//             style={{
//               opacity: 0.85,
//               fontSize: "0.95rem",
//               marginBottom: "1.25rem",
//             }}
//           >
//             AI-powered cleansing achieved in under 24h
//           </p>
//           <button
//             style={{
//               background: "rgba(255, 255, 255, 0.2)",
//               border: "none",
//               color: "white",
//               padding: "0.6rem 1.25rem",
//               borderRadius: "8px",
//               fontWeight: 500,
//               cursor: "pointer",
//             }}
//           >
//             Read Case Study
//           </button>
//         </div>
//       </div>
//     </section>

//     {/* Final CTA */}
//     <section className="py-20 bg-gradient-to-r from-blue-700 to-blue-900 text-white">
//       <div className="max-w-4xl mx-auto px-4 text-center">
//         <motion.h2 className="text-3xl md:text-4xl font-bold mb-6">
//           Ready to Unlock Your Next Growth Wave?
//         </motion.h2>
//         <motion.p className="text-xl mb-8 max-w-3xl mx-auto opacity-90">
//           Connect with our experts today for a free sample dataset or a custom
//           quote.
//         </motion.p>
//         <div className="flex flex-col sm:flex-row justify-center gap-4">
//           {/* <motion.a
//             whileHover={{
//               scale: 1.05,
//               backgroundColor: "#fff",
//               color: "#1d4ed8",
//             }}
//             whileTap={{ scale: 0.95 }}
//             href="tel:+919834567890"
//             className="px-8 py-4 bg-white text-blue-700 font-semibold rounded-lg transition-all text-lg"
//           >
//             +91 7021216035/8828357920
//           </motion.a> */}
//           <motion.a
//             whileHover={{
//               scale: 1.05,
//               backgroundColor: "#fff",
//               color: "#1d4ed8",
//             }}
//             whileTap={{ scale: 0.95 }}
//             href="/contact"
//             className="px-8 py-4 border-2 border-white text-white font-semibold rounded-lg hover:bg-white hover:text-blue-700 transition-all text-lg"
//           >
//             Get a Quote
//           </motion.a>
//           <motion.a
//             whileHover={{
//               scale: 1.05,
//               backgroundColor: "#f97316",
//               boxShadow: "0 10px 15px -3px rgba(249, 115, 22, 0.26)",
//             }}
//             whileTap={{ scale: 0.95 }}
//             href="/contact"
//             className="px-8 py-4 bg-orange-500 hover:bg-orange-600 text-white font-semibold rounded-lg transition-all text-lg"
//           >
//             Get Free Sample
//           </motion.a>
//         </div>
//       </div>
//     </section>
//   </div>
// );

// export default DataBuildServices;

import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, EffectCreative } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/effect-creative";

const services = [
  {
    title: "B2B Database Construction",
    description:
      "Target with precision. We build industry-specific databases with deep, -verified company profiles and CXO contacts to supercharge your sales and marketing efforts.",
    icon: "🏢",
    features: [
      "Segment by vertical, region, and turnover",
      "Exclusive MSME & startup enrichments",
      "Real-time KYC & MCA record match",
      "CXO, founder, and purchase head discovery",
    ],
    color: "from-blue-600 to-blue-800",
  },
  {
    title: "Event Attendee Profiling",
    description:
      "Maximize event ROI. We create detailed, GDPR-compliant attendee profiles and analyze behavior to enhance engagement and tailor future marketing.",
    icon: "🎪",
    features: [
      "Behavioral pattern scoring",
      "Personalized follow-ups",
      "ROI measurement framework",
    ],
    color: "from-purple-600 to-purple-800",
  },
  {
    title: "Market Intelligence Databases",
    description:
      "Stay ahead of the curve. We compile trends, competitive insights, and market movements into actionable, sector-specific intelligence reports for India's top industries.",
    icon: "🔍",
    features: [
      "Competitor benchmarking reports",
      "TAM/SAM/SOM sizing",
      "Emerging trend detection",
      "SWOT with India-focused context",
    ],
    color: "from-green-600 to-green-800",
  },
  {
    title: "360-Degree Customer View",
    description:
      "Deepen customer relationships. We integrate and deduplicate customer data from all touchpoints to enable hyper-personalized marketing and service strategies.",
    icon: "🔄",
    features: [
      "Multi-channel, CRM-first mapping",
      "Customer journey & engagement scoring",
      "Lifetime value (LTV) estimation",
      "Automated personalization triggers",
    ],
    color: "from-amber-600 to-amber-800",
  },
  {
    title: "Predictive Model Databases",
    description:
      "Anticipate what's next. We build the foundational datasets for AI/ML models, enabling churn prediction, propensity modeling, and future-ready planning based on Indian market behaviors.",
    icon: "🧠",
    features: [
      "Propensity & RFM segmentation",
      "B2B churn likelihood marks",
      "Next-best-action AIs",
      "Risk/fraud detection data",
    ],
    color: "from-red-600 to-red-800",
  },
  {
    title: "Compliance & Regulatory Databases",
    description:
      "Operate with confidence. We construct datasets designed for India's DPDP, GDPR, and RBI guidelines, ensuring robust governance and simplified audits.",
    icon: "🛡️",
    features: [
      "Consent management workflows",
      "Audit trail logs & reports",
      "RBI, MCA, and DPDP overlays",
      "Industry/stakeholder specific",
    ],
    color: "from-indigo-600 to-indigo-800",
  },
];

const successStories = [
  {
    metric: "40%",
    title: "Increase in Lead Quality",
    description:
      "For a fintech startup with automated firmographic enrichment & validation.",
    logo: "📊",
    caseStudy: {
      title: "Revolutionizing Lead Generation for a Fintech Unicorn",
      details:
        "A leading Indian fintech startup struggled with low-quality leads due to inconsistent data sources. We implemented an automated firmographic enrichment process, integrating real-time KYC and MCA data to build a robust B2B database tailored to their target market.",
      keyResults: [
        "40% increase in lead conversion rates",
        "80% reduction in lead qualification time",
        "Identified 10,000+ high-value prospects in 3 months",
      ],
      testimonial:
        '"Augere’s data solutions transformed our sales pipeline. The precision of their database gave us a competitive edge in targeting high-value clients." - CMO, Fintech Startup',
    },
  },
  {
    metric: "35%",
    title: "Boost in Event Engagement",
    description:
      "An edtech client saw record turnout via pre-profiled attendee segments.",
    logo: "🎯",
    caseStudy: {
      title: "Driving Record Engagement for an Edtech Expo",
      details:
        "A national edtech company aimed to maximize ROI for their annual education expo. We provided GDPR-compliant attendee profiling, leveraging behavioral pattern scoring and personalized follow-up strategies to enhance engagement.",
      keyResults: [
        "35% increase in event registrations",
        "50% higher post-event engagement rates",
        "Generated 2,500+ qualified leads from a single event",
      ],
      testimonial:
        '"The attendee insights from Augere helped us create a personalized event experience, resulting in unprecedented turnout and engagement." - Event Director, Edtech Company',
    },
  },
  {
    metric: "3x",
    title: "Faster Data Processing",
    description:
      "AI-powered cleansing achieved in under 24h for a Noida-based SaaS client.",
    logo: "⚡",
    caseStudy: {
      title: "Accelerating Data Operations for a SaaS Provider",
      details:
        "A Noida-based SaaS client faced delays in processing large datasets due to duplicates and errors. Our AI-powered data cleansing and enrichment solution streamlined their data operations, delivering clean, actionable data in record time.",
      keyResults: [
        "3x faster data processing (under 24 hours)",
        "99.5% data accuracy post-cleansing",
        "Enabled real-time analytics for 1M+ records",
      ],
      testimonial:
        '"Augere’s AI-driven approach saved us weeks of manual work and unlocked real-time insights for our platform." - CTO, SaaS Provider',
    },
  },
];

const fadeInUp = {
  hidden: { opacity: 0, y: 22 },
  visible: { opacity: 1, y: 0 },
};
const staggerContainer = { visible: { transition: { staggerChildren: 0.1 } } };

const modalVariants = {
  hidden: { opacity: 0, scale: 0.8 },
  visible: { opacity: 1, scale: 1, transition: { duration: 0.3 } },
  exit: { opacity: 0, scale: 0.8, transition: { duration: 0.2 } },
};

const Modal = ({ isOpen, onClose, caseStudy }) => (
  <AnimatePresence>
    {isOpen && (
      <motion.div
        className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
      >
        <motion.div
          className="bg-white rounded-xl p-8 max-w-lg mx-4 relative"
          variants={modalVariants}
          initial="hidden"
          animate="visible"
          exit="exit"
        >
          <button
            onClick={onClose}
            className="absolute top-4 right-4 text-gray-600 hover:text-gray-800"
          >
            <svg
              className="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
          <h2 className="text-2xl font-bold text-blue-900 mb-4">
            {caseStudy.title}
          </h2>
          <p className="text-gray-700 mb-4">{caseStudy.details}</p>
          <h3 className="text-lg font-semibold text-blue-900 mb-2">
            Key Results
          </h3>
          <ul className="space-y-2 mb-4">
            {caseStudy.keyResults.map((result, index) => (
              <li key={index} className="flex items-start">
                <svg
                  className="h-5 w-5 text-blue-600 mr-2 mt-0.5"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M5 13l4 4L19 7"
                  />
                </svg>
                <span className="text-gray-800">{result}</span>
              </li>
            ))}
          </ul>
          <p className="text-gray-700 italic">{caseStudy.testimonial}</p>
        </motion.div>
      </motion.div>
    )}
  </AnimatePresence>
);

const DataBuildServices = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedCaseStudy, setSelectedCaseStudy] = useState(null);

  const openModal = (caseStudy) => {
    setSelectedCaseStudy(caseStudy);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedCaseStudy(null);
  };

  return (
    <div className="bg-gray-50">
      {/* Hero Section */}
      <section className="relative bg-gradient-to-r from-blue-800 to-blue-900 text-white py-28 px-4 sm:px-6 lg:px-8 overflow-hidden">
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 0.1 }}
          transition={{ duration: 1.2 }}
          className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=1200&q=80')] bg-cover bg-center"
        />
        <div className="relative max-w-7xl mx-auto">
          <motion.div
            initial="hidden"
            animate="visible"
            variants={staggerContainer}
            className="text-center"
          >
            <motion.h1
              variants={fadeInUp}
              className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 font-serif"
            >
              Data Build Services
            </motion.h1>
            <motion.p
              variants={fadeInUp}
              className="text-xl md:text-2xl max-w-3xl mx-auto"
            >
              From Raw Data to Strategic Advantage
            </motion.p>
          </motion.div>
        </div>
      </section>

      {/* Expertise Intro */}
      <section className="py-20 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto">
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={staggerContainer}
          className="grid md:grid-cols-2 gap-12 items-center"
        >
          <motion.div variants={fadeInUp}>
            <h2 className="text-3xl md:text-4xl font-bold text-blue-900 mb-6 font-serif">
              Transforming Data into Actionable Intelligence
            </h2>
            <p className="text-lg text-gray-700 mb-6">
              At Augere Strategies, we specialize in crafting bespoke data
              solutions that empower businesses to make informed decisions and
              drive growth. We blend deep local expertise with robust processes
              to turn complex, unstructured data into your most valuable
              strategic asset.
            </p>
            <div className="space-y-4">
              {[
                "500M+ validated business contacts",
                "99% data accuracy",
                "Real-time data refreshes with consent trail",
              ].map((item, index) => (
                <motion.div
                  key={index}
                  variants={fadeInUp}
                  whileHover={{ x: 4 }}
                  className="flex items-start"
                >
                  <svg
                    className="h-6 w-6 text-blue-600 mr-3 mt-0.5"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M5 13l4 4L19 7"
                    />
                  </svg>
                  <span className="text-gray-800 font-medium">{item}</span>
                </motion.div>
              ))}
            </div>
          </motion.div>
          <motion.div
            variants={fadeInUp}
            whileHover={{ scale: 1.03 }}
            transition={{ duration: 0.3 }}
            className="relative"
          >
            <div className="absolute -inset-4 bg-gradient-to-r from-blue-600 to-yellow-400 rounded-2xl opacity-15 blur-lg" />
            <div className="relative bg-white p-1 rounded-xl shadow-xl overflow-hidden">
              <img
                src="https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-4.0.3&auto=format&fit=crop&w=900&q=80"
                alt="Data analytics team"
                className="w-full h-auto rounded-lg"
              />
            </div>
          </motion.div>
        </motion.div>
      </section>

      {/* Our Approach */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={staggerContainer}
            className="text-center mb-16"
          >
            <motion.h2
              variants={fadeInUp}
              className="text-3xl md:text-4xl font-bold text-blue-900 mb-4 font-serif"
            >
              Our Process for Building Intelligence
            </motion.h2>
            <motion.p
              variants={fadeInUp}
              className="text-xl text-gray-700 max-w-3xl mx-auto"
            >
              A stepwise, audit-friendly process from discovery to enrichment
              and compliance.
            </motion.p>
          </motion.div>
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={staggerContainer}
            className="grid md:grid-cols-2 lg:grid-cols-3 gap-8"
          >
            {[
              {
                title: "Discover & Assess",
                icon: "🔎",
                desc: "We analyze your existing data landscape to identify key information and potential gaps.",
                color: "bg-blue-100 text-blue-700",
              },
              {
                title: "Architect & Design",
                icon: "🧩",
                desc: "Our experts design tailored data structures that align with your specific business goals.",
                color: "bg-orange-100 text-orange-700",
              },
              {
                title: "Integrate & Unify",
                icon: "🔄",
                desc: "We seamlessly combine data from multiple sources, creating a unified and comprehensive dataset.",
                color: "bg-green-100 text-green-700",
              },
              {
                title: "Cleanse & Enrich",
                icon: "✨",
                desc: "Our robust processes ensure your data is accurate, up-to-date, and enriched with valuable attributes.",
                color: "bg-amber-100 text-amber-700",
              },
              {
                title: "Analyze & Predict",
                icon: "📊",
                desc: "We apply cutting-edge analytical techniques to uncover hidden patterns and generate predictive insights.",
                color: "bg-red-100 text-red-700",
              },
              {
                title: "Visualize & Report",
                icon: "📈",
                desc: "We transform complex data into clear, intuitive visualizations and reports for easy interpretation and strategy.",
                color: "bg-indigo-100 text-indigo-700",
              },
            ].map((step, i) => (
              <motion.div
                key={step.title}
                variants={fadeInUp}
                whileHover={{
                  y: -8,
                  boxShadow: "0 12px 24px 0 rgba(37, 99, 235, 0.12)",
                }}
                className={`bg-gray-50 p-8 rounded-xl border border-gray-200 flex flex-col items-center ${step.color}`}
              >
                <div className="text-4xl mb-3">{step.icon}</div>
                <h3 className="text-xl font-bold text-blue-900 mb-2">
                  {step.title}
                </h3>
                <p className="text-gray-700 text-center">{step.desc}</p>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </section>

      {/* Our Data Build Services */}
      <section className="py-20 bg-gradient-to-br from-gray-100 to-blue-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={staggerContainer}
            className="text-center mb-14"
          >
            <motion.h2
              variants={fadeInUp}
              className="text-3xl md:text-4xl font-bold text-blue-900 mb-4 font-serif"
            >
              Our Data Build Solutions
            </motion.h2>
            <motion.p
              variants={fadeInUp}
              className="text-xl text-gray-700 max-w-3xl mx-auto"
            >
              Engineered for Results: Choose a solution to see how we empower
              your business with actionable data.
            </motion.p>
          </motion.div>
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={staggerContainer}
            className="grid md:grid-cols-2 lg:grid-cols-3 gap-8"
          >
            {services.map((service, index) => (
              <motion.div
                key={service.title}
                variants={fadeInUp}
                whileHover={{
                  y: -12,
                  boxShadow: "0 14px 26px 0 rgba(59, 130, 246, 0.17)",
                }}
                className="bg-white rounded-xl shadow px-0 pb-0 overflow-hidden transition-all duration-300 group"
              >
                <div
                  className={`h-44 bg-gradient-to-r ${service.color} flex items-center relative`}
                >
                  <div className="absolute left-5 top-7 text-5xl text-white">
                    {service.icon}
                  </div>
                  <h3 className="absolute left-5 bottom-4 text-xl font-bold text-white drop-shadow">
                    {service.title}
                  </h3>
                  <div className="absolute right-0 bottom-0 w-44 h-36 bg-white/10 blur-2xl rounded-full"></div>
                </div>
                <div className="p-6">
                  <p className="text-gray-700 mb-3">{service.description}</p>
                  <ul className="space-y-2 mb-4">
                    {service.features.map((feature, i) => (
                      <li key={i} className="flex items-start">
                        <svg
                          className="h-5 w-5 text-blue-600 mr-2 mt-0.5"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M5 13l4 4L19 7"
                          />
                        </svg>
                        <span className="text-gray-800">{feature}</span>
                      </li>
                    ))}
                  </ul>
                  <motion.a
                    href="/contact"
                    whileHover={{
                      scale: 1.04,
                      backgroundColor: "#1e40af",
                      color: "#fff",
                    }}
                    whileTap={{ scale: 0.96 }}
                    className="w-full py-2 px-4 border border-blue-700 text-blue-700 font-semibold rounded-lg hover:bg-blue-700 hover:text-white transition-all text-center"
                  >
                    Learn More
                  </motion.a>
                </div>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </section>

      {/* Proven Impact Section */}
      <section
        style={{
          maxWidth: "1000px",
          margin: "2rem auto",
          padding: "2.5rem",
          background: "linear-gradient(135deg, #1e40af 0%, #3730a3 100%)",
          color: "white",
          borderRadius: "16px",
          boxShadow: "0 10px 30px rgba(0, 0, 0, 0.15)",
        }}
      >
        <div style={{ textAlign: "center", marginBottom: "2.5rem" }}>
          <div
            style={{
              display: "inline-block",
              background: "rgba(255, 255, 255, 0.15)",
              padding: "0.5rem 1rem",
              borderRadius: "20px",
              fontSize: "0.85rem",
              fontWeight: 500,
              marginBottom: "1rem",
            }}
          >
            SUCCESS METRICS
          </div>
          <h2
            style={{
              fontSize: "2rem",
              fontWeight: 700,
              marginBottom: "0.75rem",
              color: "white",
            }}
          >
            Proven Impact
          </h2>
          <p
            style={{
              fontSize: "1.1rem",
              opacity: 0.9,
              maxWidth: "500px",
              margin: "0 auto",
            }}
          >
            Real results for enterprises, from unicorns to MSMEs.
          </p>
        </div>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
            gap: "1.25rem",
          }}
        >
          {successStories.map((story, index) => (
            <div
              key={index}
              style={{
                background: "rgba(255, 255, 255, 0.1)",
                borderRadius: "12px",
                padding: "1.5rem",
                textAlign: "center",
              }}
            >
              <div
                style={{
                  fontSize: "2.5rem",
                  fontWeight: 700,
                  color: "#93c5fd",
                  marginBottom: "0.5rem",
                }}
              >
                {story.metric}
              </div>
              <h3
                style={{
                  fontSize: "1.25rem",
                  fontWeight: 600,
                  marginBottom: "0.75rem",
                }}
              >
                {story.title}
              </h3>
              <p
                style={{
                  opacity: 0.85,
                  fontSize: "0.95rem",
                  marginBottom: "1.25rem",
                }}
              >
                {story.description}
              </p>
              <motion.button
                whileHover={{
                  scale: 1.05,
                  backgroundColor: "#fff",
                  color: "#1e40af",
                }}
                whileTap={{ scale: 0.95 }}
                style={{
                  background: "rgba(255, 255, 255, 0.2)",
                  border: "none",
                  color: "white",
                  padding: "0.6rem 1.25rem",
                  borderRadius: "8px",
                  fontWeight: 500,
                  cursor: "pointer",
                }}
                onClick={() => openModal(story.caseStudy)}
              >
                Read Case Study
              </motion.button>
            </div>
          ))}
        </div>
      </section>

      {/* Modal for Case Studies */}
      <Modal
        isOpen={isModalOpen}
        onClose={closeModal}
        caseStudy={selectedCaseStudy || {}}
      />

      {/* Final CTA */}
      <section className="py-20 bg-gradient-to-r from-blue-700 to-blue-900 text-white">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <motion.h2 className="text-3xl md:text-4xl font-bold mb-6">
            Ready to Unlock Your Next Growth Wave?
          </motion.h2>
          <motion.p className="text-xl mb-8 max-w-3xl mx-auto opacity-90">
            Connect with our experts today for a free sample dataset or a custom
            quote.
          </motion.p>
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <motion.a
              whileHover={{
                scale: 1.05,
                backgroundColor: "#fff",
                color: "#1d4ed8",
              }}
              whileTap={{ scale: 0.95 }}
              href="/contact"
              className="px-8 py-4 border-2 border-white text-white font-semibold rounded-lg hover:bg-white hover:text-blue-700 transition-all text-lg"
            >
              Get a Quote
            </motion.a>
            <motion.a
              whileHover={{
                scale: 1.05,
                backgroundColor: "#f97316",
                boxShadow: "0 10px 15px -3px rgba(249, 115, 22, 0.26)",
              }}
              whileTap={{ scale: 0.95 }}
              href="/contact"
              className="px-8 py-4 bg-orange-500 hover:bg-orange-600 text-white font-semibold rounded-lg transition-all text-lg"
            >
              Get Free Sample
            </motion.a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default DataBuildServices;
